import { render, staticRenderFns } from "./UploadPreview.vue?vue&type=template&id=476762f5&scoped=true&"
import script from "./UploadPreview.vue?vue&type=script&lang=js&"
export * from "./UploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadPreview.vue?vue&type=style&index=0&id=476762f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476762f5",
  null
  
)

export default component.exports